<template>
  <history-api ref="history" @popstate="state => sync(state || defaultQuery, false)">
    <template v-slot:default="{ pushState }">
      <component
        :is="component"
        @navigated="pushState({ page: $event }, url, { preserveScroll: false })"></component>
    </template>
  </history-api>
</template>

<script>
import TheGalleryDesktop from './TheGalleryDesktop.vue'
import TheGalleryMobile from './TheGalleryMobile.vue'
import HistoryApi from '../../Universal/HistoryApi.vue'
import querystring from 'qs-stringify'
import pickBy from 'lodash/pickBy'

export default {
  components: {
    HistoryApi,
  },

  provide () {
    return {
      query: this.query,
      filters: this.filters,
      api: this.api,
      queryActions: {
        clear: this.clear,
        sync: this.sync,
      },
    }
  },

  data () {
    return {
      query: jsonFromPage('#data-query'),
      api: jsonFromPage('#data-api'),
    }
  },

  methods: {
    clear () {
      Object.assign(this.query, this.defaultQuery)
      this.sync(this.query)
    },

    sync (query, pushState = true) {
      Object.assign(this.query, query)
      if (pushState) {
        this.$nextTick(() => this.$refs.history.pushState(query, this.url))
      }
    },
  },

  computed: {
    filters () {
      return jsonFromPage('#data-filters')
    },

    defaultQuery () {
      return jsonFromPage('#data-default-query')
    },

    component () {
      return this.$mq.lg ? TheGalleryDesktop : TheGalleryMobile
    },

    url () {
      return `${this.path}?${querystring(pickBy(this.query, value => Array.isArray(value) ? value.length > 0 : value))}`
    },

    path () {
      return this.query.categories.length === 1 ? `/artworks/category/${this.query.categories[0]}` : '/artworks'
    },
  },

  watch: {
    path (path) {
      axios.get(path, {headers: {'X-Inertia': true}})
        .then(({data: {breadcrumbs, meta: {title}}}) => {
          TheBreadcrumb.replace(breadcrumbs)
          document.title = title
        })
    }
  }
}
</script>
